export type LangRegionProps = {
    name: string;
    lang: string;
    region: string;
    countries: string[];
    legacyRegion?: string;
};

export const allLangRegions: LangRegionProps[] = [
    {
        // default regionless language (has to be at the top of the list)
        name: 'English',
        lang: 'en',
        region: 'us',
        countries: ['us'],
    },
    {
        name: 'Spanish (Spain)',
        lang: 'es',
        region: 'es',
        countries: ['es'],
    },
    {
        name: 'Canada',
        lang: 'en',
        region: 'ca',
        countries: ['ca'],
    },
    {
        name: 'UK or Ireland',
        lang: 'en',
        region: 'gb_ie',
        legacyRegion: 'uk',
        countries: ['gb', 'ie', 'gg', 'im', 'je'],
    },
    {
        name: 'Danish',
        lang: 'da',
        region: 'dk',
        countries: ['dk', 'gl', 'fo'],
    },
    {
        name: 'French',
        lang: 'fr',
        region: 'fr',
        countries: ['fr', 'bl', 'gf', 'gp', 'mf', 'mq', 'pm', 're', 'yt'],
    },
    {
        name: 'German',
        lang: 'de',
        region: 'gsa',
        countries: ['de', 'at', 'ch'],
    },
    {
        name: 'Italian',
        lang: 'it',
        region: 'it',
        countries: ['it', 'sm', 'va'],
    },
    {
        name: 'Norwegian',
        lang: 'no',
        region: 'no',
        countries: ['no', 'sj'],
    },
    {
        name: 'Norwegian Bokmål',
        lang: 'nb',
        region: 'no',
        countries: ['no', 'sj'],
    },
    {
        name: 'Finnish',
        lang: 'fi',
        region: 'fi',
        countries: ['fi', 'ax'],
    },
    {
        name: 'Swedish',
        lang: 'sv',
        region: 'se',
        countries: ['se'],
    },
    {
        name: 'Australia',
        lang: 'en',
        region: 'au',
        countries: ['au'],
    },
    {
        name: 'Brazil',
        lang: 'pt',
        region: 'br',
        countries: ['br'],
    },
    {
        name: 'Portuguese',
        lang: 'pt',
        region: 'pt',
        countries: ['pt'],
    },
    {
        name: 'Spanish (Latin America)',
        lang: 'es',
        region: 'latam',
        countries: [
            'ar', // please do not change the order of the top 4 countries
            'mx',
            'cl',
            'bo',
            'co',
            'cr',
            'do',
            'ec',
            'gt',
            'hn',
            'ni',
            'pa',
            'pe',
            'py',
            'sv',
            'uy',
            've',
        ],
    },
];
